import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import TextField from "components/ui/controls/text-field/text-field";
import LigneImpotDetaille from "./LigneImpot";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import "./ContexteFiscal.css";

const BicBncAvantAbattement = (props) => {
  const { Outil } = props;
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const Periode = context.state[Outil + "PeriodeActuelle"] === undefined ? undefined : context.state[Outil + "PeriodeActuelle"][0];
  const PeriodeConjoint = context.state[Outil + "PeriodeActuelleConjoint"] === undefined ? undefined : context.state[Outil + "PeriodeActuelleConjoint"][0];

  let RemunerationDeclaree = 0;
  let RemunerationDeclareeConjoint = 0;

  if (context.state.TypeSimulation === "Audit rémunération") {
    if (Outil === "") {
      if (Periode?.Statut === "TNS individuel") {
        if (context.state.ModeExercice === "IS") {
          RemunerationDeclaree =
            Number(ResultatTNS.state["RemExpressRemuneration"]?.BrutImposable) -
            (Number(ResultatTNS.state["RemExpressRemuneration"]?.BrutImposable) * context.state.PartRemunerationMandat) / 100;
        } else {
          RemunerationDeclaree = ResultatTNS.state["RemExpressRemuneration"]?.BrutImposable;
        }
      }
    } else if (Outil === "OptiRem") {
      if (context.state.OptiRemModeExercice === "IS") {
        RemunerationDeclaree =
          Number(ResultatTNS.state.OptiRemRemuneration?.BrutImposable) - (Number(ResultatTNS.state.OptiRemRemuneration?.BrutImposable) * context.state.OptiRemPartRemunerationMandat) / 100;
      } else {
        RemunerationDeclaree = ResultatTNS.state.OptiRemRemuneration?.BrutImposable;
      }
    } else {
      RemunerationDeclaree = ResultatTNS.state[Outil + "RemunerationTNS"]?.BrutImposable;
    }
  } else {
    if (Outil === "") {
      if (Periode?.Statut === "TNS individuel") {
        if (Periode?.ModeExercice === "IS") {
          RemunerationDeclaree =
            ResultatTNS.state[Outil + "RemunerationTNS"]?.BrutImposable - (ResultatTNS.state[Outil + "RemunerationTNS"]?.BrutImposable * Periode?.PartRemunerationMandat) / 100;
        } else {
          RemunerationDeclaree = ResultatTNS.state[Outil + "RemunerationTNS"]?.BrutImposable;
        }
      }
      if (context.state.InclureConjoint === true) {
        if (Periode?.StatutConjoint === "TNS individuel") {
          if (Periode?.ModeExercice === "IS") {
            RemunerationDeclareeConjoint =
              ResultatTNS.state[Outil + "RemunerationTNSConjoint"]?.BrutImposable -
              (ResultatTNS.state[Outil + "RemunerationTNSConjoint"]?.BrutImposable * Periode?.PartRemunerationMandatConjoint) / 100;
          } else {
            RemunerationDeclareeConjoint = ResultatTNS.state[Outil + "RemunerationTNSConjoint"]?.BrutImposable;
          }
        } else if (PeriodeConjoint?.Statut === "TNS individuel") {
          if (PeriodeConjoint?.ModeExercice === "IS") {
            RemunerationDeclareeConjoint =
              ResultatTNS.state[Outil + "RemunerationTNSConjoint"]?.BrutImposable -
              (ResultatTNS.state[Outil + "RemunerationTNSConjoint"]?.BrutImposable * PeriodeConjoint?.PartRemunerationMandat) / 100;
          } else {
            RemunerationDeclareeConjoint = ResultatTNS.state[Outil + "RemunerationTNSConjoint"]?.BrutImposable;
          }
        }
      }
    } else if (Outil === "OptiRem") {
      if (Periode?.Statut === "TNS individuel") {
        if (Periode?.ModeExercice === "IS") {
          RemunerationDeclaree =
            Number(ResultatTNS.state.OptiRemRemuneration?.BrutImposable) - (Number(ResultatTNS.state.OptiRemRemuneration?.BrutImposable) * Periode?.PartRemunerationMandat) / 100;
        } else {
          RemunerationDeclaree = ResultatTNS.state.OptiRemRemuneration?.BrutImposable;
        }
      }

      if (context.state.InclureConjoint === true) {
        if (Periode?.StatutConjoint === "TNS individuel") {
          if (Periode?.ModeExercice === "IS") {
            RemunerationDeclareeConjoint =
              ResultatTNS.state.OptiRemRemunerationConjoint?.BrutImposable - (ResultatTNS.state.OptiRemRemunerationConjoint?.BrutImposable * Periode?.PartRemunerationMandatConjoint) / 100;
          } else {
            RemunerationDeclareeConjoint = ResultatTNS.state.OptiRemRemunerationConjoint?.BrutImposable;
          }
        } else if (PeriodeConjoint?.Statut === "TNS individuel") {
          if (PeriodeConjoint?.ModeExercice === "IS") {
            RemunerationDeclareeConjoint =
              ResultatTNS.state.OptiRemRemunerationConjoint?.BrutImposable - (ResultatTNS.state.OptiRemRemunerationConjoint?.BrutImposable * PeriodeConjoint?.PartRemunerationMandat) / 100;
          } else {
            RemunerationDeclareeConjoint = ResultatTNS.state.OptiRemRemunerationConjoint?.BrutImposable;
          }
        }
      }
    }
  }

  return (
    <div className="revenuspro-container">
      {/* Header séparé */}
      <div className="header-card">
        <div className="category-column">
          <span className="header-icon">💼</span>
          Catégorie
        </div>
        <div className="value-column">
          <span className="header-icon">👤</span>
          Client
        </div>
        <div className="value-column">
          <span className="header-icon">👥</span>
          Conjoint
        </div>
      </div>

      {/* Conteneur des cartes de contenu */}
      <div className="card-list-container">
        {/* Rémunération déclarée */}
        {Periode !== undefined && (
          <div className="card">
            <div className="category-column">
              <div className="titre-icone">€</div>
              Rémunération déclarée sur l'activité étudiée
            </div>
            <div className="value-column">
              <TextField
                value={RemunerationDeclaree}
                dataType="uint"
                format={{ thousands: " ", unit: " €" }}
                normal
                disabled={true}
              />
            </div>
            <div className="value-column">
              {context.state.TypeSimulation !== "Audit rémunération" && (
                <TextField
                  value={RemunerationDeclareeConjoint}
                  dataType="uint"
                  format={{ thousands: " ", unit: " €" }}
                  normal
                  disabled={true}
                />
              )}
            </div>
          </div>
        )}

        {/* BNC régime micro */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📋</div>
            BNC régime micro
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantBNCMicro"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantBNCMicro")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointBNCMicro"]}
              onChange={context.handleInputChange(Outil + "IRConjointBNCMicro")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* BNC régime de la déclaration contrôlée */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📄</div>
            BNC régime de la déclaration contrôlée
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantBNCControlle"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantBNCControlle")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointBNCControlle"]}
              onChange={context.handleInputChange(Outil + "IRConjointBNCControlle")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* BIC régime micro : activité d'achat revente, logement */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">🏪</div>
            BIC régime micro : activité d'achat revente, logement
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantBICMicroAchatRevente"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantBICMicroAchatRevente")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointBICMicroAchatRevente"]}
              onChange={context.handleInputChange(Outil + "IRConjointBICMicroAchatRevente")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* BIC régime micro : activité de service */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">🔧</div>
            BIC régime micro : activité de service
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantBICMicroService"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantBICMicroService")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointBICMicroService"]}
              onChange={context.handleInputChange(Outil + "IRConjointBICMicroService")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* BIC régime réel simplifié ou normal */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📊</div>
            BIC régime réel simplifié ou normal
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantBICReel"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantBICReel")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointBICReel"]}
              onChange={context.handleInputChange(Outil + "IRConjointBICReel")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* BA régime micro */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">🚜</div>
            BA régime micro
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantBAMicro"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantBAMicro")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointBAMicro"]}
              onChange={context.handleInputChange(Outil + "IRConjointBAMicro")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* BA régime réel simplifié ou normal */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">🌾</div>
            BA régime réel simplifié ou normal
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantBAReel"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantBAReel")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointBAReel"]}
              onChange={context.handleInputChange(Outil + "IRConjointBAReel")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BicBncAvantAbattement;
